import { Route, Routes } from 'react-router'
import ChatWidget from './components/ChatWidget'
import 'react-toastify/dist/ReactToastify.css'
import { ToastContainer } from 'react-toastify'

interface AppProps {
  updateSW: (val: boolean) => Promise<void>
  showReload: boolean
}
const App = ({ showReload, updateSW }: AppProps) => {
  return (
    <>
      {showReload && (
        <div>
          <button onClick={() => updateSW(true)}>Refresh</button>
        </div>
      )}
      <Routes>
        <Route
          path='/'
          element={<ChatWidget defaultOpen={false} siteName={''} />}
        />
        <Route
          path='/chat'
          element={<ChatWidget defaultOpen={true} siteName='piprolink' />}
        />
      </Routes>
      <ToastContainer />
    </>
  )
}

export default App
